import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { useT } from "../i18n/I18nProvider";
import LanguageSwitcher from "./LanguageSwitcher";
import { MobileMenu } from "./MobileMenu";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_digital-sculptors/artifacts/qnqijai9_Logo%20Mysterious%20Stew.png";

export function useNavItems() {
  const t = useT();
  return [
    { to: "/", label: t("nav.studio"), end: true, key: "studio" },
    { to: "/servizi", label: t("nav.servizi"), key: "servizi" },
    { to: "/portfolio", label: t("nav.portfolio"), key: "portfolio" },
    { to: "/studio", label: t("nav.team"), key: "team" },
    { to: "/journal", label: t("nav.journal"), key: "journal" },
  ];
}

export const Header = () => {
  const t = useT();
  const navItems = useNavItems();
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header className="sticky top-0 z-50 glass" data-testid="site-header">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 h-16 sm:h-20 flex items-center justify-between gap-3">
        <Link
          to="/"
          data-testid="logo-link"
          className="flex items-center gap-2.5 sm:gap-3 group min-w-0"
        >
          <span className="relative inline-flex w-9 h-9 sm:w-10 sm:h-10 rounded-full overflow-hidden bg-white ring-1 ring-ink-200 shrink-0">
            <img
              src={LOGO_URL}
              alt="Mysterious Stew"
              className="w-full h-full object-cover"
            />
          </span>
          <div className="leading-tight min-w-0">
            <div className="font-display text-[14px] sm:text-[15px] tracking-tight truncate">
              Mysterious Stew
            </div>
            <div className="hidden sm:block overline text-[9px] mt-0.5">
              {t("nav.studioTagline")}
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 lg:gap-10">
          {navItems.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`nav-${n.key}`}
              className={({ isActive }) =>
                `text-[13px] font-medium tracking-wide transition-colors underline-grow ${
                  isActive ? "text-ink-900" : "text-ink-500 hover:text-ink-900"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <LanguageSwitcher />
          <div className="hidden md:block">
            <Link
              to="/contatti"
              data-testid="header-contact-cta"
              className="btn-pill"
            >
              {t("nav.parliamone")}
              <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.6} />
            </Link>
          </div>
          <button
            className="md:hidden w-11 h-11 inline-flex items-center justify-center rounded-full hairline bg-white shrink-0"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-btn"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
          </button>
        </div>
      </div>

      {open && <MobileMenu navItems={navItems} />}
    </header>
  );
};
